<template>
    <div>
        <div class="item-wrapper">
            <div class="container-fluid" style="position: relative">
                <div class="row">
                    <custom-product-quick-search-card
                        v-for="product in coloredProducts"
                        :key="product.id"
                        :coloredProduct="product"
                        :gant="gant"
                        :vermont="vermont"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import customProductQuickSearchCard from '../card/custom-quick-search-card.vue';

export default {
    components: { customProductQuickSearchCard },
    props: {
        coloredProducts: {},
        gant: { type: Boolean },
        vermont: { type: Boolean },
    },
};
</script>
